import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Steps from 'antd/lib/steps';
import Popover from 'antd/lib/popover';

const getProgressSteps = t => [
  {
    title: t('Osobné údaje'),
    description: '',
  },
  {
    title: t('Adresa a údaje o rodine'),
    description: '',
  },
  {
    title: t('Vzdelanie a financie'),
    description: '',
  },
  {
    title: t('Poistenie'),
    description: '',
  },
];

const CustomDot = (dot, { description }) =>
  description ? <Popover content={<span>{description}</span>}>{dot}</Popover> : dot;

@translate()
export default class StepProgress extends Component {
  static propTypes = {
    current: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const { current, t } = this.props;

    const steps = getProgressSteps(t);

    return (
      <section className="steps-wrapper">
        <Steps current={current} progressDot={CustomDot}>
          {steps.map((step, idx) => (
            <Steps.Step
              title={step.title}
              description={step.description}
              key={idx}
              className={`step-index-${idx}`}
            />
          ))}
        </Steps>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/debtor/StepProgress.js